import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const NotFound = lazy(() => import("../pages/NotFound"));
const InvestmentReportPage = lazy(() => import("../pages/project-dashboard/investment-report/page"));
const ArgumentEvalDashboardPage = lazy(() => import("../pages/project-dashboard/argument-evaluation/page"));
const PanoramaCockpitPage = lazy(() => import("../pages/project-dashboard/panorama-cockpit/page"));
const ProjectDetailPage = lazy(() => import("../pages/project-dashboard/project-detail/page"));
const ApprovalProcessPage = lazy(() => import("../pages/project-plan/approval-process/page"));
const ZhongteStageReviewPage = lazy(() => import("../pages/project-plan/plan-review/zhongte-stage/page"));
const JointOpinionSignPage = lazy(() => import("../pages/project-plan/joint-opinion-sign/page"));
const InitJointOpinionSignPage = lazy(() => import("../pages/project-initiation/joint-opinion-sign/page"));
const LeaderReviewPage = lazy(() => import("../pages/project-plan/leader-review/page"));
const PlanArchivePage = lazy(() => import("../pages/project-plan/plan-archive/page"));
const PlanPaymentReportPage = lazy(() => import("../pages/project-plan/payment-report/page"));
const ProjectPlanDeclaration = lazy(() => import("../pages/project-plan/declaration/page"));
const PlanFormPage = lazy(() => import("../pages/project-plan/declaration/form/page"));
const PlanDeferralPage = lazy(() => import("../pages/project-plan/plan-deferral/page"));
const PlanDeferralFormPage = lazy(() => import("../pages/project-plan/plan-deferral/form/page"));
const ArgumentApplyPage = lazy(() => import("../pages/project-argument/apply/page"));
const ArgumentApplyFormPage = lazy(() => import("../pages/project-argument/apply/form/page"));
const OpinionSignPage = lazy(() => import("../pages/project-argument/opinion-sign/page"));
const OpinionSignFormPage = lazy(() => import("../pages/project-argument/opinion-sign/form/page"));
const InitDeclarationPage = lazy(() => import("../pages/project-initiation/declaration/page"));
const InitDeclarationFormPage = lazy(() => import("../pages/project-initiation/declaration/form/page"));
const InitZhongteStageReviewPage = lazy(() => import("../pages/project-initiation/plan-review/zhongte-stage/page"));
const InitLeaderReviewPage = lazy(() => import("../pages/project-initiation/leader-review/page"));
const InitOfficePrelimReviewPage = lazy(() => import("../pages/project-initiation/office-prelim-review/page"));
const InitOverviewPage = lazy(() => import("../pages/project-initiation/overview/page"));
const InitOverviewDetailPage = lazy(() => import("../pages/project-initiation/overview/detail/page"));
const InitPlanDeferralPage = lazy(() => import("../pages/project-initiation/plan-deferral/page"));
const InitPlanDeferralFormPage = lazy(() => import("../pages/project-initiation/plan-deferral/form/page"));
const ContractListPage = lazy(() => import("../pages/project-execute/quality-safety/contract-list/page"));
const IssueListPage = lazy(() => import("../pages/project-execute/quality-safety/issue-list/page"));
const SafetyIssuesContractListPage = lazy(() => import("../pages/project-execute/safety-issues/contract-list/page"));
const SafetyIssuesIssueListPage = lazy(() => import("../pages/project-execute/safety-issues/issue-list/page"));
const ProcessQualityContractListPage = lazy(() => import("../pages/project-execute/process-quality/contract-list/page"));
const ProcessQualityChecklistPage = lazy(() => import("../pages/project-execute/process-quality/checklist/page"));
const OwnerSupplyProjectListPage = lazy(() => import("../pages/project-execute/owner-supply/project-list/page"));
const OwnerSupplyDetailPage = lazy(() => import("../pages/project-execute/owner-supply/detail/page"));
const ContractBreachContractListPage = lazy(() => import("../pages/project-execute/contract-breach/contract-list/page"));
const ContractBreachChecklistPage = lazy(() => import("../pages/project-execute/contract-breach/checklist/page"));
const ProjectPrepareListPage = lazy(() => import("../pages/project-prepare/project-management/list/page"));
const MemberListPage = lazy(() => import("../pages/project-prepare/project-management/members/page"));
const EstimateListPage = lazy(() => import("../pages/project-prepare/estimate-management/list/page"));
const EstimateApplyPage = lazy(() => import("../pages/project-prepare/estimate-management/apply/page"));
const EstimateCostDetailPage = lazy(() => import("../pages/project-prepare/estimate-management/cost-detail/page"));
const ContractProgressListPage = lazy(() => import("../pages/project-contract/progress/list/page"));
const ReportListPage = lazy(() => import("../pages/project-contract/progress/reports/page"));
const ReportDetailPage = lazy(() => import("../pages/project-contract/progress/report-detail/page"));
const WBSPage = lazy(() => import("../pages/project-contract/progress/wbs/page"));
const RequirementListPage = lazy(() => import("../pages/project-contract/requirement/list/page"));
const DemandListPage = lazy(() => import("../pages/project-contract/requirement/demand-list/page"));
const DemandFormPage = lazy(() => import("../pages/project-contract/requirement/form/page"));
const DemandDetailPage = lazy(() => import("../pages/project-contract/requirement/detail/page"));
const TechAgreementJointReviewPage = lazy(() => import("../pages/project-contract/tech-agreement/joint-review/page"));
const TechAgreementOpinionSignPage = lazy(() => import("../pages/project-contract/tech-agreement/opinion-sign/page"));
const TechAgreementFinalReviewPage = lazy(() => import("../pages/project-contract/tech-agreement/final-review/page"));
const GanttPage = lazy(() => import("../pages/project-contract/progress/gantt/page"));
const ContractExecutionListPage = lazy(() => import("../pages/project-contract/execution/list/page"));
const ContractExecutionCommencementPage = lazy(() => import("../pages/project-contract/execution/commencement/page"));
const ContractExecutionApprovePage = lazy(() => import("../pages/project-contract/execution/approve/page"));
const ContractExecutionDetailPage = lazy(() => import("../pages/project-contract/execution/detail/page"));
const HandoverApprovePage = lazy(() => import("../pages/project-contract/execution/handover-approve/page"));
const HandoverDetailPage = lazy(() => import("../pages/project-contract/execution/handover-detail/page"));
const StopResumeFormPage = lazy(() => import("../pages/project-contract/execution/stop-resume-form/page"));
const StopResumeDetailPage = lazy(() => import("../pages/project-contract/execution/stop-resume-detail/page"));
const CompletionProjectReviewPage = lazy(() => import("../pages/project-contract/execution/completion-project-review/page"));
const CompletionManufacturingReviewPage = lazy(() => import("../pages/project-contract/execution/completion-manufacturing-review/page"));
const CompletionDetailPage = lazy(() => import("../pages/project-contract/execution/completion-detail/page"));
const ExecutionDelayDetailPage = lazy(() => import("../pages/project-contract/execution/delay-detail/page"));
const ExecutionChangeDetailPage = lazy(() => import("../pages/project-contract/execution/change-detail/page"));
const ExecutionPricingDetailPage = lazy(() => import("../pages/project-contract/execution/pricing-detail/page"));
const ExecutionHandoverViewPage = lazy(() => import("../pages/project-contract/execution/handover-view/page"));
const ExecutionPunchlistDetailPage = lazy(() => import("../pages/project-contract/execution/punchlist-detail/page"));
const ExecutionCompletionViewPage = lazy(() => import("../pages/project-contract/execution/completion-view/page"));
const ProjectApprovalListPage = lazy(() => import("../pages/project-prepare/approval/list/page"));
const ProjectApprovalStagePage = lazy(() => import("../pages/project-prepare/approval/stage/page"));
const FrameworkContractPage = lazy(() => import("../pages/project-sporadic/framework-contract/page"));
const SporadicRequirementPlanPage = lazy(() => import("../pages/project-sporadic/requirement-plan/page"));
const AgreementDeclarePage = lazy(() => import("../pages/project-sporadic/agreement-declare/page"));
const AgreementFormPage = lazy(() => import("../pages/project-sporadic/agreement-declare/form/page"));
const AgreementReviewPage = lazy(() => import("../pages/project-sporadic/agreement-review/page"));
const AgreementIssuePage = lazy(() => import("../pages/project-sporadic/agreement-issue/page"));
const AgreementIssueFormPage = lazy(() => import("../pages/project-sporadic/agreement-issue/form/page"));
const SporadicPaymentPage = lazy(() => import("../pages/project-sporadic/payment/page"));
const SporadicExecutionPage = lazy(() => import("../pages/project-sporadic/execution/page"));
const ContractDocumentListPage = lazy(() => import("../pages/project-contract/document/list/page"));
const ContractDocumentFormPage = lazy(() => import("../pages/project-contract/document/form/page"));
const ContractDocumentDetailPage = lazy(() => import("../pages/project-contract/document/detail/page"));
const ContractOverviewDetailPage = lazy(() => import("../pages/project-contract/overview/detail/page"));
const ContractSupplementListPage = lazy(() => import("../pages/project-contract/document/supplement/page"));
const ContractAmountSupplementListPage = lazy(() => import("../pages/project-contract/document/amount-supplement/page"));
const PaymentDeclarationListPage = lazy(() => import("../pages/project-contract/payment-declaration/list/page"));
const PaymentDeclarationAppListPage = lazy(() => import("../pages/project-contract/payment-declaration/declaration-list/page"));
const PaymentProjectReviewPage = lazy(() => import("../pages/project-contract/payment-declaration/project-review/page"));
const PaymentSupervisoryReviewPage = lazy(() => import("../pages/project-contract/payment-declaration/supervisory-review/page"));
const PaymentFinanceReviewPage = lazy(() => import("../pages/project-contract/payment-declaration/finance-review/page"));
const PaymentDeclarationDetailPage = lazy(() => import("../pages/project-contract/payment-declaration/detail/page"));
const EarlyEvaluationListPage = lazy(() => import("../pages/project-close/early-evaluation/page"));
const PostEvalListPage = lazy(() => import("../pages/project-close/post-evaluation/page"));
const PostEvalCatalogPage = lazy(() => import("../pages/project-close/post-evaluation/catalog/page"));
const PostEvalSelfPage = lazy(() => import("../pages/project-close/post-evaluation/self-eval/page"));
const PostEvalProfPage = lazy(() => import("../pages/project-close/post-evaluation/prof-eval/page"));
const PostEvalCompPage = lazy(() => import("../pages/project-close/post-evaluation/comp-eval/page"));
const KnowledgeBasePage = lazy(() => import("../pages/engineering-think-tank/knowledge-base/page"));
const ArchiveConfigPage = lazy(() => import("../pages/project-archive/config/page"));
const ArchiveConfigPreviewPage = lazy(() => import("../pages/project-archive/config/preview/page"));
const ArchiveManagementListPage = lazy(() => import("../pages/project-archive/management/list/page"));
const ArchiveManagementDetailPage = lazy(() => import("../pages/project-archive/management/detail/page"));
const ProjectProgressListPage = lazy(() => import("../pages/project-execute/progress/list/page"));
const WeeklyMonthlyPage = lazy(() => import("../pages/project-execute/progress/weekly-monthly/page"));
const ReportDetailPage2 = lazy(() => import("../pages/project-execute/progress/weekly-monthly/detail/page"));
const ProgressReportPage = lazy(() => import("../pages/project-execute/progress/report/page"));
const ProjectGanttPage = lazy(() => import("../pages/project-execute/progress/gantt/page"));
const ArchiveManagementPreviewPage = lazy(() => import("../pages/project-archive/management/preview/page"));
const MonitorConfigListPage = lazy(() => import("../pages/system-config/monitor-config/page"));
const MonitorDeviceConfigPage = lazy(() => import("../pages/system-config/monitor-config/config/page"));
const ApprovalPermitConfigPage = lazy(() => import("../pages/system-config/approval-permit-config/page"));
const LeadershipTeamConfigPage = lazy(() => import("../pages/system-config/leadership-team-config/page"));
const CommencementCheckConfigPage = lazy(() => import("../pages/system-config/commencement-check-config/page"));
const AssessmentItemConfigPage = lazy(() => import("../pages/system-config/assessment-item/page"));
const CompletionProjectListPage = lazy(() => import("../pages/project-execute/completion/project-list/page"));
const TechRenovationListPage = lazy(() => import("../pages/project-execute/completion/tech-renovation/page"));
const CompletionApplicationListPage = lazy(() => import("../pages/project-execute/completion/application-list/page"));
const CompletionApplicationFormPage = lazy(() => import("../pages/project-execute/completion/application-form/page"));
const ConstructionMemberListPage = lazy(() => import("../pages/participant/construction-member/list/page"));
const ConstructionMemberDetailPage = lazy(() => import("../pages/participant/construction-member/detail/page"));
const SupervisorContractLinkPage = lazy(() => import("../pages/participant/supervisor-contract-link/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ProjectPlanDeclaration />,
  },
  {
    path: "/project-plan/approval-process",
    element: <ApprovalProcessPage />,
  },
  {
    path: "/project-plan/declaration",
    element: <ProjectPlanDeclaration />,
  },
  {
    path: "/project-plan/declaration/form",
    element: <PlanFormPage />,
  },
  {
    path: "/project-plan/declaration/form/new",
    element: <PlanFormPage />,
  },
  {
    path: "/project-plan/declaration/form/tech",
    element: <PlanFormPage />,
  },
  {
    path: "/project-plan/declaration/form/overhaul",
    element: <PlanFormPage />,
  },
  {
    path: "/project-plan/declaration/form/minor",
    element: <PlanFormPage />,
  },
  {
    path: "/project-plan/plan-deferral",
    element: <PlanDeferralPage />,
  },
  {
    path: "/project-plan/plan-deferral/form",
    element: <PlanDeferralFormPage />,
  },
  {
    path: "/project-plan/plan-review/zhongte-stage",
    element: <ZhongteStageReviewPage />,
  },
  {
    path: "/project-plan/joint-opinion-sign",
    element: <JointOpinionSignPage />,
  },
  {
    path: "/project-plan/leader-review",
    element: <LeaderReviewPage />,
  },
  {
    path: "/project-plan/plan-archive",
    element: <PlanArchivePage />,
  },
  {
    path: "/project-plan/payment-report",
    element: <PlanPaymentReportPage />,
  },
  {
    path: "/project-dashboard/panorama-cockpit",
    element: <PanoramaCockpitPage />,
  },
  {
    path: "/project-dashboard/investment-report",
    element: <InvestmentReportPage />,
  },
  {
    path: "/project-dashboard/argument-evaluation",
    element: <ArgumentEvalDashboardPage />,
  },
  {
    path: "/project-dashboard/project-detail",
    element: <ProjectDetailPage />,
  },
  {
    path: "/project-argument/apply",
    element: <ArgumentApplyPage />,
  },
  {
    path: "/project-argument/apply/form",
    element: <ArgumentApplyFormPage />,
  },
  {
    path: "/project-argument/opinion-sign",
    element: <OpinionSignPage />,
  },
  {
    path: "/project-argument/opinion-sign/form",
    element: <OpinionSignFormPage />,
  },
  {
    path: "/project-initiation/overview",
    element: <InitOverviewPage />,
  },
  {
    path: "/project-initiation/overview/detail",
    element: <InitOverviewDetailPage />,
  },
  {
    path: "/project-initiation/declaration",
    element: <InitDeclarationPage />,
  },
  {
    path: "/project-initiation/declaration/form",
    element: <InitDeclarationFormPage />,
  },
  {
    path: "/project-initiation/declaration/form/new",
    element: <InitDeclarationFormPage />,
  },
  {
    path: "/project-initiation/declaration/form/tech",
    element: <InitDeclarationFormPage />,
  },
  {
    path: "/project-initiation/declaration/form/overhaul",
    element: <InitDeclarationFormPage />,
  },
  {
    path: "/project-initiation/declaration/form/minor",
    element: <InitDeclarationFormPage />,
  },
  {
    path: "/project-initiation/office-prelim-review",
    element: <InitOfficePrelimReviewPage />,
  },
  {
    path: "/project-initiation/plan-review/zhongte-stage",
    element: <InitZhongteStageReviewPage />,
  },
  {
    path: "/project-initiation/joint-opinion-sign",
    element: <InitJointOpinionSignPage />,
  },
  {
    path: "/project-initiation/leader-review",
    element: <InitLeaderReviewPage />,
  },
  {
    path: "/project-initiation/plan-deferral",
    element: <InitPlanDeferralPage />,
  },
  {
    path: "/project-initiation/plan-deferral/form",
    element: <InitPlanDeferralFormPage />,
  },
  {
    path: "/project-execute/safety-issues",
    element: <SafetyIssuesContractListPage />,
  },
  {
    path: "/project-execute/safety-issues/issues",
    element: <SafetyIssuesIssueListPage />,
  },
  {
    path: "/project-execute/quality-safety",
    element: <ContractListPage />,
  },
  {
    path: "/project-execute/quality-safety/issues",
    element: <IssueListPage />,
  },
  {
    path: "/project-execute/process-quality",
    element: <ProcessQualityContractListPage />,
  },
  {
    path: "/project-execute/process-quality/checklist",
    element: <ProcessQualityChecklistPage />,
  },
  {
    path: "/project-execute/owner-supply",
    element: <OwnerSupplyProjectListPage />,
  },
  {
    path: "/project-execute/owner-supply/detail",
    element: <OwnerSupplyDetailPage />,
  },
  {
    path: "/participant/contract-breach",
    element: <ContractBreachContractListPage />,
  },
  {
    path: "/participant/contract-breach/checklist",
    element: <ContractBreachChecklistPage />,
  },
  {
    path: "/project-execute/contract-breach",
    element: <ContractBreachContractListPage />,
  },
  {
    path: "/project-execute/contract-breach/checklist",
    element: <ContractBreachChecklistPage />,
  },
  {
    path: "/participant/supervisor-contract-link",
    element: <SupervisorContractLinkPage />,
  },
  {
    path: "/project-prepare/project-management",
    element: <ProjectPrepareListPage />,
  },
  {
    path: "/project-prepare/project-management/members",
    element: <MemberListPage />,
  },
  {
    path: "/project-prepare/estimate-management",
    element: <EstimateListPage />,
  },
  {
    path: "/project-prepare/estimate-management/apply",
    element: <EstimateApplyPage />,
  },
  {
    path: "/project-prepare/estimate-management/cost-detail",
    element: <EstimateCostDetailPage />,
  },
  {
    path: "/project-contract/progress",
    element: <ContractProgressListPage />,
  },
  {
    path: "/project-contract/requirement",
    element: <RequirementListPage />,
  },
  {
    path: "/project-contract/requirement/demand-list",
    element: <DemandListPage />,
  },
  {
    path: "/project-contract/requirement/form",
    element: <DemandFormPage />,
  },
  {
    path: "/project-contract/requirement/detail",
    element: <DemandDetailPage />,
  },
  {
    path: "/project-contract/tech-agreement/joint-review",
    element: <TechAgreementJointReviewPage />,
  },
  {
    path: "/project-contract/tech-agreement/opinion-sign",
    element: <TechAgreementOpinionSignPage />,
  },
  {
    path: "/project-contract/tech-agreement/final-review",
    element: <TechAgreementFinalReviewPage />,
  },
  {
    path: "/project-contract/progress/reports",
    element: <ReportListPage />,
  },
  {
    path: "/project-contract/progress/report-detail",
    element: <ReportDetailPage />,
  },
  {
    path: "/project-contract/progress/wbs",
    element: <WBSPage />,
  },
  {
    path: "/project-contract/progress/gantt",
    element: <GanttPage />,
  },
  {
    path: "/project-contract/execution",
    element: <ContractExecutionListPage />,
  },
  {
    path: "/project-contract/execution/list",
    element: <ContractExecutionCommencementPage />,
  },
  {
    path: "/project-contract/execution/approve",
    element: <ContractExecutionApprovePage />,
  },
  {
    path: "/project-contract/execution/detail",
    element: <ContractExecutionDetailPage />,
  },
  {
    path: "/project-contract/execution/handover-approve",
    element: <HandoverApprovePage />,
  },
  {
    path: "/project-contract/execution/handover-detail",
    element: <HandoverDetailPage />,
  },
  {
    path: "/project-contract/execution/stop-resume-form",
    element: <StopResumeFormPage />,
  },
  {
    path: "/project-contract/execution/stop-resume-detail",
    element: <StopResumeDetailPage />,
  },
  {
    path: "/project-contract/execution/delay-detail",
    element: <ExecutionDelayDetailPage />,
  },
  {
    path: "/project-contract/execution/change-detail",
    element: <ExecutionChangeDetailPage />,
  },
  {
    path: "/project-contract/execution/pricing-detail",
    element: <ExecutionPricingDetailPage />,
  },
  {
    path: "/project-contract/execution/handover-view",
    element: <ExecutionHandoverViewPage />,
  },
  {
    path: "/project-contract/execution/punchlist-detail",
    element: <ExecutionPunchlistDetailPage />,
  },
  {
    path: "/project-contract/execution/completion-view",
    element: <ExecutionCompletionViewPage />,
  },
  {
    path: "/project-contract/execution/completion-project-review",
    element: <CompletionProjectReviewPage />,
  },
  {
    path: "/project-contract/execution/completion-manufacturing-review",
    element: <CompletionManufacturingReviewPage />,
  },
  {
    path: "/project-contract/execution/completion-detail",
    element: <CompletionDetailPage />,
  },
  {
    path: "/project-prepare/approval",
    element: <ProjectApprovalListPage />,
  },
  {
    path: "/project-prepare/approval/stage",
    element: <ProjectApprovalStagePage />,
  },
  {
    path: "/project-sporadic/requirement-plan",
    element: <SporadicRequirementPlanPage />,
  },
  {
    path: "/project-sporadic/framework-contract",
    element: <FrameworkContractPage />,
  },
  {
    path: "/project-sporadic/agreement-declare",
    element: <AgreementDeclarePage />,
  },
  {
    path: "/project-sporadic/agreement-declare/form",
    element: <AgreementFormPage />,
  },
  {
    path: "/project-sporadic/agreement-review",
    element: <AgreementReviewPage />,
  },
  {
    path: "/project-sporadic/agreement-issue",
    element: <AgreementIssuePage />,
  },
  {
    path: "/project-sporadic/agreement-issue/form",
    element: <AgreementIssueFormPage />,
  },
  {
    path: "/project-sporadic/payment",
    element: <SporadicPaymentPage />,
  },
  {
    path: "/project-sporadic/execution",
    element: <SporadicExecutionPage />,
  },
  {
    path: "/project-contract/document",
    element: <ContractDocumentListPage />,
  },
  {
    path: "/project-contract/document/form",
    element: <ContractDocumentFormPage />,
  },
  {
    path: "/project-contract/document/detail",
    element: <ContractDocumentDetailPage />,
  },
  {
    path: "/project-contract/document/overview",
    element: <ContractOverviewDetailPage />,
  },
  {
    path: "/project-contract/document/supplement",
    element: <ContractSupplementListPage />,
  },
  {
    path: "/project-contract/document/amount-supplement",
    element: <ContractAmountSupplementListPage />,
  },
  {
    path: "/project-contract/payment-declaration",
    element: <PaymentDeclarationListPage />,
  },
  {
    path: "/project-contract/payment-declaration/declaration-list",
    element: <PaymentDeclarationAppListPage />,
  },
  {
    path: "/project-contract/payment-declaration/project-review",
    element: <PaymentProjectReviewPage />,
  },
  {
    path: "/project-contract/payment-declaration/supervisory-review",
    element: <PaymentSupervisoryReviewPage />,
  },
  {
    path: "/project-contract/payment-declaration/finance-review",
    element: <PaymentFinanceReviewPage />,
  },
  {
    path: "/project-contract/payment-declaration/detail",
    element: <PaymentDeclarationDetailPage />,
  },
  {
    path: "/project-close/early-evaluation",
    element: <EarlyEvaluationListPage />,
  },
  {
    path: "/project-close/post-evaluation",
    element: <PostEvalListPage />,
  },
  {
    path: "/project-close/post-evaluation/catalog",
    element: <PostEvalCatalogPage />,
  },
  {
    path: "/project-close/post-evaluation/self-eval",
    element: <PostEvalSelfPage />,
  },
  {
    path: "/project-close/post-evaluation/prof-eval",
    element: <PostEvalProfPage />,
  },
  {
    path: "/project-close/post-evaluation/comp-eval",
    element: <PostEvalCompPage />,
  },
  {
    path: "/engineering-think-tank/knowledge-base",
    element: <KnowledgeBasePage />,
  },
  {
    path: "/project-archive/config",
    element: <ArchiveConfigPage />,
  },
  {
    path: "/project-archive/config/preview",
    element: <ArchiveConfigPreviewPage />,
  },
  {
    path: "/project-archive/management",
    element: <ArchiveManagementListPage />,
  },
  {
    path: "/project-archive/management/detail",
    element: <ArchiveManagementDetailPage />,
  },
  {
    path: "/project-archive/management/preview",
    element: <ArchiveManagementPreviewPage />,
  },
  {
    path: "/project-execute/progress",
    element: <ProjectProgressListPage />,
  },
  {
    path: "/project-execute/progress/weekly-monthly",
    element: <WeeklyMonthlyPage />,
  },
  {
    path: "/project-execute/progress/weekly-monthly/detail",
    element: <ReportDetailPage2 />,
  },
  {
    path: "/project-execute/progress/report",
    element: <ProgressReportPage />,
  },
  {
    path: "/project-execute/progress/gantt",
    element: <ProjectGanttPage />,
  },
  {
    path: "/project-execute/completion",
    element: <CompletionProjectListPage />,
  },
  {
    path: "/project-execute/completion/tech-renovation",
    element: <TechRenovationListPage />,
  },
  {
    path: "/project-execute/completion/application-list",
    element: <CompletionApplicationListPage />,
  },
  {
    path: "/project-execute/completion/application-form",
    element: <CompletionApplicationFormPage />,
  },
  {
    path: "/system-config/monitor-config",
    element: <MonitorConfigListPage />,
  },
  {
    path: "/system-config/monitor-config/config",
    element: <MonitorDeviceConfigPage />,
  },
  {
    path: "/system-config/approval-permit-config",
    element: <ApprovalPermitConfigPage />,
  },
  {
    path: "/system-config/leadership-team-config",
    element: <LeadershipTeamConfigPage />,
  },
  {
    path: "/system-config/commencement-check-config",
    element: <CommencementCheckConfigPage />,
  },
  {
    path: "/system-config/assessment-item",
    element: <AssessmentItemConfigPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/participant/construction-member",
    element: <ConstructionMemberListPage />,
  },
  {
    path: "/participant/construction-member/detail",
    element: <ConstructionMemberDetailPage />,
  },
];

export default routes;